import React, { useRef, useEffect } from "react";
import s from "./style.module.css";
import "./style.css";
import Vizualisation from "../../../../components/Vizualisation";
import useVizualisation from "../../../../helpers/useVizualisation";
import ColorLegend from "../../../../components/ColorLegend/colorLegend";
import { select } from "d3-selection";
import { scaleBand, scaleOrdinal } from "d3-scale";
import { axisLeft } from "d3-axis";
import topsitesData from "../../data/topsites.json";
import { Text } from "@visx/text";
import Tooltip from "./../Tooltip";

const SiteMap = ({
  data,
  title,
  note,
  source,
  value,
  highlight,
  armenia,
  tunisia,
  morocco,
  sriLanka,
  peru,
  ukraine,
  philippines,
  colombia,
  bangladesh,
  egypt,
  kenya,
  southAfrica,
  malaysia,
  nigeria,
  russia,
  indonesia,
  brazil,
  placeRanking,
  search,
  socialMedia,
  eCommerce,
  entertainment,
  other,
  video,
  software,
  classifieds,
  realEstate,
  tooltipNumber,
  tooltipIn,
}) => {
  const { ref, width, height, windowSize, inView } = useVizualisation();

  const margin = {
    top: 50,
    right: 30,
    bottom: 10,
    left: width < 700 ? 70 : 90,
  };

  const translationsMap = {
    Armenia: armenia,
    Tunisia: tunisia,
    Morocco: morocco,
    "Sri Lanka": sriLanka,
    Peru: peru,
    Ukraine: ukraine,
    Philippines: philippines,
    Colombia: colombia,
    Bangladesh: bangladesh,
    "Egypt, Arab Rep.": egypt,
    Kenya: kenya,
    "South Africa": southAfrica,
    Malaysia: malaysia,
    Nigeria: nigeria,
    Russia: russia,
    Indonesia: indonesia,
    Brazil: brazil,
    Search: search,
    "Social media": socialMedia,
    "E-commerce": eCommerce,
    Entertainment: entertainment,
    Other: other,
    "Video communication": video,
    "Software/computing resources": software,
    Classifieds: classifieds,
    "Real estate": realEstate,
  };

  const chartData = topsitesData;

  let plotData = chartData;
  if (value == 2) {
    plotData = chartData.filter((d) => d["F/D"] === "F");
  } else if (value == 3 || value == 4) {
    plotData = chartData.filter((d) => d["Owner HQ"] === "United States");
  } else if (value == 5) {
    plotData = chartData.filter(
      (d) =>
        d["GUO (if applicable)"] === "Google" ||
        d["GUO (if applicable)"] === "Microsoft" ||
        d["GUO (if applicable)"] === "Facebook"
    );
  }

  const yAxisRef = useRef(null);
  const tooltipRef = useRef(null);

  const chartWidth = width - margin.left - margin.right;
  const chartHeight = height - margin.top - margin.bottom;

  const categoryColorScale = scaleOrdinal().range([
    "#27575F",
    "#50969C",
    "#4574B1",
    "#DD6950",
    "#CCCCCC",
    "#BF5C6D",
    "#A3624C",
    "#422577",
    "#EBC147",
  ]);

  let yDomain = [...new Set(chartData.map((d) => d.Country))];
  let categoryColorDomain = [
    ...new Set(chartData.map((d) => d["Category.general"])),
  ];

  /*let companyColorDomain = [
    ...new Set(plotData.map((d) => d["GUO (if applicable)"])),
  ];*/
  const companyColorDomain = [
    "Google",
    "Facebook",
    "Zoom",
    "Amazon",
    "Verizon Media",
    "Stack Exchange",
    "Microsoft",
    "Ebay",
    "Twitter",
  ];
  let companyColorScale = scaleOrdinal()
    .range([
      "#DB4437", //Google
      "#4267B2", //Facebook
      "#2D8CFF", // Zoom
      "#FF9900", //Amazon
      "#444444", //Verizon Media
      "#8BD1ED", //Stack Excange
      "#7FBA00", //Microsoft
      "#6F2165", //Ebay
      "#AAB8C2", //Twitter
    ])
    .domain(companyColorDomain);

  categoryColorScale.domain(categoryColorDomain);
  const categoryColorScaleTranslated = scaleOrdinal()
    .domain(categoryColorDomain.map((d) => translationsMap[d]))
    .range([
      "#27575F",
      "#50969C",
      "#4574B1",
      "#DD6950",
      "#CCCCCC",
      "#BF5C6D",
      "#A3624C",
      "#422577",
      "#EBC147",
    ]);

  const xScale = scaleBand()
    .domain(Array.from({ length: 25 }, (_, i) => i + 1))
    .range([0, chartWidth]);

  const yScale = scaleBand().domain(yDomain).range([0, chartHeight]);

  const yAxis = axisLeft(yScale);

  useEffect(() => {
    select(yAxisRef.current).call(yAxis);
  });

  return (
    <>
      <ColorLegend
        colorscale={
          value == 4 || value == 5
            ? companyColorScale
            : categoryColorScaleTranslated
        }
      ></ColorLegend>
      <Vizualisation
        title={title}
        note={note}
        source={source}
        ref={ref}
        size="xLarge"
      >
        <svg width={width} height={500}>
          <defs>
            <marker
              id="arrow"
              viewBox="0 -10 20 20"
              refX={5}
              refY={0}
              markerWidth={8}
              markerHeight={8}
              orient="auto"
            >
              <path d="M0,-10L20,0L0,10" className="arrowhead"></path>
            </marker>
          </defs>
          <g
            className="chart"
            transform={`translate(${margin.left}, ${margin.top})`}
          >
            <g className="g-axis">
              <g
                className="axis axis--y"
                transform={`translate(${chartWidth}, 0)`}
                ref={yAxisRef}
              ></g>
              <g className={"x-axis-explanation"}>
                <line
                  x1={width > 699 ? chartWidth / 2 - 170 : 40}
                  x2={6}
                  y1={-14}
                  y2={-14}
                  strokeWidth={1}
                  stroke={"#000000"}
                  markerEnd={`url(#arrow)`}
                ></line>
                <line
                  x1={width > 699 ? chartWidth / 2 + 170 : chartWidth - 40}
                  x2={chartWidth}
                  y1={-14}
                  y2={-14}
                  strokeWidth={1}
                  stroke={"#000000"}
                ></line>
                <Text
                  x={chartWidth / 2}
                  y={-10}
                  textAnchor={"middle"}
                  verticalAnchor={"end"}
                  fontSize="12px"
                  fontWeight={"bold"}
                  width={width < 500 ? chartWidth : 700}
                >
                  {placeRanking}
                </Text>
              </g>
              <g>
                {yScale.domain().map((d) => {
                  return (
                    <Text
                      x={-4}
                      y={yScale(d) + yScale.bandwidth() / 2}
                      verticalAnchor={"middle"}
                      textAnchor={"end"}
                      width={width < 700 ? 70 : 100}
                      fontSize={11}
                    >
                      {translationsMap[d]}
                    </Text>
                  );
                })}
              </g>
            </g>
            {plotData.map((d) => {
              return (
                <>
                  <a href={"https://" + d.Site} target="_blank">
                    <rect
                      key={`rect-${d.Country}-${d.Rank}`}
                      x={xScale(d.Rank)}
                      y={yScale(d.Country)}
                      width={xScale.bandwidth()}
                      height={yScale.bandwidth()}
                      fill={
                        value == 4 || value == 5
                          ? companyColorScale(d["GUO (if applicable)"])
                          : categoryColorScale(d["Category.general"])
                      }
                      stroke={"#ffffff"}
                      strokeWidth={1}
                      onMouseOver={() => {
                        const end = xScale(d.Rank) > width / 2 ? true : false;
                        const xOffset = end
                          ? margin.right - 65
                          : margin.left + 50;
                        const yOffset = 20;

                        tooltipRef.current.handleMouseOver(
                          d,
                          xScale(d.Rank),
                          yScale(d.Country),
                          xOffset,
                          yOffset,
                          width,
                          end
                        );
                      }}
                      onMouseLeave={() => {
                        tooltipRef.current.handleMouseOut();
                      }}
                    ></rect>
                    {width > 699 && (
                      <Text
                        x={xScale(d.Rank) + xScale.bandwidth() / 2}
                        y={yScale(d.Country) + yScale.bandwidth() / 2}
                        verticalAnchor={"middle"}
                        textAnchor={"middle"}
                        fill={"#ffffff"}
                        fontSize={12}
                        opacity={0.6}
                        className={s.cellLabel}
                      >
                        {d.Rank}
                      </Text>
                    )}
                  </a>
                </>
              );
            })}
          </g>
        </svg>
        <Tooltip
          ref={tooltipRef}
          translationsMap={translationsMap}
          tooltipNumber={tooltipNumber}
          tooltipIn={tooltipIn}
        />
      </Vizualisation>
    </>
  );
};

export default SiteMap;
